import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { FcGoogle } from "react-icons/fc";
import { authMe } from "./adminApi";
import { Seo } from "../seo/Seo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AdminLogin() {
  const nav = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setChecking(false); return; }
    authMe().then(() => nav("/admin", { replace: true })).catch(() => setChecking(false));
  }, [nav]);

  const startGoogle = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-white text-[#0a0a0a] flex items-center justify-center px-6">
      <Seo title="Admin — Manuel Santana" description="Admin login." path="/admin/login" schemas={[]} />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <span className="font-mono-ui text-[10px] tracking-[0.3em] text-[#C8102E]">MS</span>
          <span className="font-display text-2xl">Manuel Santana — Admin</span>
        </div>
        <p className="font-mono-ui text-[11px] tracking-[0.3em] uppercase text-[#C8102E] mb-3">— Restricted</p>
        <h1 className="font-display text-5xl md:text-6xl tracking-[-0.02em] mb-4">Sign in.</h1>
        <p className="text-black/60 mb-12 leading-relaxed">Only the allowlisted Google account can access this dashboard.</p>

        {checking ? (
          <p className="font-mono-ui text-[11px] tracking-[0.2em] uppercase text-black/40">Checking session…</p>
        ) : (
          <button
            data-testid="admin-login-google"
            onClick={startGoogle}
            className="inline-flex items-center gap-3 bg-[#0a0a0a] text-white hover:bg-[#C8102E] border border-[#0a0a0a] hover:border-[#C8102E] px-6 py-4 font-mono-ui text-[11px] tracking-[0.2em] uppercase transition-all"
          >
            <FcGoogle size={20} className="bg-white rounded-sm" />
            Continue with Google
          </button>
        )}

        <p className="mt-16 font-mono-ui text-[10px] tracking-[0.3em] uppercase text-black/35 flex items-center gap-2">
          <Lock size={11} /> iammanuelsantana.com · admin
        </p>
      </div>
    </div>
  );
}
